import { PublicNav, Footer } from "../components/PublicLayout";
import { PricingCards } from "../components/PricingCards";

export default function Pricing() {
  return (
    <div className="min-h-screen bg-background" data-testid="pricing-page">
      <PublicNav />
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-20">
        <div className="max-w-2xl mb-12">
          <p className="text-xs tracking-[0.25em] uppercase font-semibold text-muted-foreground mb-3">Choose your plan</p>
          <h1 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight" data-testid="pricing-title">
            Simple, transparent pricing
          </h1>
          <p className="mt-4 text-muted-foreground leading-relaxed">
            Secure payment via Stripe. The monthly plan renews automatically and can be cancelled anytime. The 3, 6 and 12-month plans are prepaid access periods. Your question history is kept permanently.
          </p>
        </div>
        <PricingCards />
        <p className="mt-10 text-xs text-muted-foreground max-w-2xl leading-relaxed">
          Prices include access to the full published question bank, quiz and test modes, progress tracking, explanations and review tools. Card details are processed securely by Stripe and never touch our servers.
        </p>
      </div>
      <Footer />
    </div>
  );
}
